import KeenSlider from 'keen-slider';
import 'keen-slider/keen-slider.min.css';

// quotes and their slider
document.addEventListener('DOMContentLoaded', function () {
  class BlockQuotes extends HTMLElement {
    constructor() {
      super();
      // elements
      this.keenSlider = null;
      this.slider = this.querySelector('.keen-slider');
      this.current = this.querySelector('.js-quotes__current');
      this.nextSelector = '.js-quotes__next';
      this.prevSelector = '.js-quotes__prev';
    }
    connectedCallback() {
      this.onLoad();
      // bindings
      // events
    }

    disconnectedCallback() {
      if (this.keenSlider.destroy) this.keenSlider.destroy();
    }
    onLoad() {
      this.initSlider();
    }
    initSlider() {
      if (!this.slider) return;
      this.keenSlider = new KeenSlider(this.slider, {
        slides: {
          perView: 1,
          spacing: 40
        }
      }, [slider => {
        const next = this.querySelector(this.nextSelector);
        const prev = this.querySelector(this.prevSelector);
        const refreshArrows = () => {
          const details = slider.track.details;
          const current = details?.rel ?? 0;
          prev?.removeAttribute('disabled');
          next?.removeAttribute('disabled');
          if (current === 0) {
            prev?.setAttribute('disabled', 'disabled');
          }
          if (current >= details.maxIdx) {
            next?.setAttribute('disabled', 'disabled');
          }
        };
        const updateAriaAttributes = () => {
          const details = slider.track.details;
          const current = details?.rel ?? 0;
          // Update aria-current attributes on slides
          slider.slides.forEach((slide, index) => {
            if (index === current) {
              slide.setAttribute('aria-current', 'true');
            } else {
              slide.setAttribute('aria-current', 'false');
            }
          });
        };
        slider.on('created', () => {
          refreshArrows();
          updateAriaAttributes();
          slider.container?.classList.add('is-ready');
          next?.addEventListener('click', () => {
            slider.next();
          });
          prev?.addEventListener('click', () => {
            slider.prev();
          });
        });
        slider.on('slideChanged', () => {
          refreshArrows();
          updateAriaAttributes();
          const details = slider.track.details;
          if (this.current) {
            this.current.textContent = details.rel + 1;
          }
        });
      }]);
    }
  }
  customElements.define('block-quotes', BlockQuotes);
});